import React from "react";
import style from "./SearchTool.module.css";

export const SearchTool = () => {
  return (
    <>
      <div className={style.magnifier}></div>
    </>
  );
};
